import {
  type CanvasElementFrom,
  type CanvasElementOverride,
  type CanvasElementOverrides,
  type CanvasElementOverrideTarget,
  type CanvasElementProperties,
  type CanvasElementType,
  getRenderSourcesByTarget,
  mergeProps,
  type PropsOf,
  type RenderTarget,
} from '@blaze-runtime/engine-domain';

import { hasProps } from './element-props-guards';

const TARGETS: CanvasElementOverrideTarget[] = ['tablet', 'mobile'];

export function forEachOverride(
  overrides: CanvasElementOverrides | undefined,
  callback: (override: CanvasElementOverride, target: CanvasElementOverrideTarget) => void,
): void {
  if (!overrides) {
    return;
  }
  for (const target of TARGETS) {
    const override = overrides[target];
    if (override) {
      callback(override, target);
    }
  }
}

export function mergePropsByTarget<
  P extends CanvasElementProperties | undefined = CanvasElementProperties,
>(
  props: P,
  overrides: CanvasElementOverrides<P> | undefined,
  renderTarget: RenderTarget = 'desktop',
): P {
  return mergeProps(getRenderSourcesByTarget[renderTarget](props, overrides));
}

export function mergeElementPropsByTarget<T extends CanvasElementType = CanvasElementType>(
  element: CanvasElementFrom<T>,
  renderTarget: RenderTarget = 'desktop',
): PropsOf<T> | undefined {
  if (!hasProps(element)) {
    return undefined;
  }

  return mergePropsByTarget<PropsOf<T>>(
    element.props as any,
    element.overrides as CanvasElementOverrides<any>,
    renderTarget,
  );
}
